export default __webpack_public_path__ + "static/media/thermo-page-image.2846e4c8.png";